import type { ReactNode } from "react"

import { ToastBody } from "./ToastBody"
import { ToastContent } from "./ToastContent"
import { ToastContext } from "./ToastContext"
import { ToastIcon } from "./ToastIcon"
import { ToastNotification } from "./ToastNotification"
import type { ToastOptions } from "./ToastOptions"
import { ToastText } from "./ToastText"
import { ToastTitle } from "./ToastTitle"
import { useToast } from "./useToast"

export interface Props extends ToastOptions {
  children?: ReactNode;
  title?: string;
  body?: string;
}

/*
 * the toast adds content to a fixed list at the top of the page that is overlaid over
 * the rest of the page content
 */
export function Toast({
  body,
  children,
  title,
  ...options
}: Props) {
  const value = useToast(options)

  return (
    <ToastContext.Provider value={value}>
      {children || (
        <ToastContent>
          <ToastNotification>
            <ToastIcon />
            <ToastText>
              {title && (
                <ToastTitle>
                  {title}
                </ToastTitle>
              )}
              {body && (
                <ToastBody>
                  {body}
                </ToastBody>
              )}
            </ToastText>
          </ToastNotification>
        </ToastContent>
      )}
    </ToastContext.Provider>
  )
}
